var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div class=\"loader container\">\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <h1 class=\"page-header\">Collection Loader</h1>\n    </div>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-lg-12\">\n      <div class=\"well\">\n        <form>\n          <div class=\"form-group\">\n            <select class=\"select-model form-control\">\n              <option>Select model</option>");
// iterate this.models
;(function(){
  var $$obj = this.models;
  if ('number' == typeof $$obj.length) {

    for (var name = 0, $$l = $$obj.length; name < $$l; name++) {
      var model = $$obj[name];

buf.push("\n              <option" + (jade.attr("value", "" + (name) + "", true, false)) + ">" + (jade.escape((jade_interp = name) == null ? '' : jade_interp)) + "</option>");
    }

  } else {
    var $$l = 0;
    for (var name in $$obj) {
      $$l++;      var model = $$obj[name];

buf.push("\n              <option" + (jade.attr("value", "" + (name) + "", true, false)) + ">" + (jade.escape((jade_interp = name) == null ? '' : jade_interp)) + "</option>");
    }

  }
}).call(this);

buf.push("\n            </select>\n          </div>\n          <div class=\"form-group\">\n            <div class=\"input-group\">\n              <input type=\"text\" name=\"key\" placeholder=\"Key\" autocomplete=\"off\" class=\"form-control\"/>\n              <div class=\"input-group-addon\"><span class=\"fa fa-play\"></span></div>\n            </div>\n          </div>\n          <div class=\"form-group\">\n            <button type=\"submit\" class=\"btn btn-warning\">Load</button>\n          </div>\n        </form>\n        <div class=\"result\"></div>\n      </div>\n    </div>\n  </div>\n</div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}